<script>
import axios from "axios";
import moment from "moment";
import Modal from "../components/shared/Modal/Modal.vue";
import { DataService } from "../config/dataService";
import store from "../vuex/store";
import Chat from "./ChatHistory/Chat.vue";
import ChatList from "./ChatHistory/ChatList.vue";
import Select from "./ChatHistory/Select.vue";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

const HISTORIES_TYPES = {
  ALL: "All",
  NOT_ANONYMOUS: "Not anonymous",
  ANONYMOUS: "Anonymous",
  FAVORITE: "Favorite",
};

const itemsForSelect = [
  {
    type: HISTORIES_TYPES.ALL,
    icon: {
      source: require("../assets/icons/widget.svg"),
      id: "#widget",
    },
  },
  {
    type: HISTORIES_TYPES.NOT_ANONYMOUS,
    icon: {
      source: require("../assets/icons/happy.svg"),
      id: "#happy",
    },
  },
  {
    type: HISTORIES_TYPES.ANONYMOUS,
    icon: {
      source: require("../assets/icons/anonymous.svg"),
      id: "#anonymous",
    },
  },
  {
    type: HISTORIES_TYPES.FAVORITE,
    icon: {
      source: require("../assets/icons/star.svg"),
      id: "#star",
    },
  },
];

export default {
  components: {
    Select,
    ChatList,
    Chat,
    Modal,
  },
  data() {
    return {
      historyActionsIcons: [
        {
          source: require("../assets/icons/refresh.svg"),
          id: "#refresh",
          action: this.refreshHistory,
        },
        {
          source: require("../assets/icons/archive_load.svg"),
          id: "#archive_load",
          action: this.allHistoryDownload,
        },
      ],

      chatActionsIcons: [
        {
          source: require("../assets/icons/star_light.svg"),
          id: "#star_light",
          source_2: require("../assets/icons/star.svg"),
          id_2: "#star",
          action: this.toggleFavorite,
        },
        // {
        //   source: require("../assets/icons/all_done.svg"),
        //   id: "#all_done",
        //   action: () => console.log("#all_done"),
        // },
        {
          source: require("../assets/icons/download.svg"),
          id: "#download",
          action: this.selectedHistoryDownload,
        },
        // {
        //   source: require("../assets/icons/dots.svg"),
        //   id: "#dots",
        //   action: () => console.log("#dots"),
        // },
      ],
      historyList: [],
      historyChat: {
        messages: [
          {
            question: "",
            aCreatedAt: Date.now(),
            answer: "",
            qCreatedAt: Date.now(),
          },
        ],
        user: { name: "", email: "", phone: "" },
      },
      filter: HISTORIES_TYPES.ALL,
      selected: null,
      showModal: false,
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    selectItems() {
      return itemsForSelect;
    },

    chosenWidget() {
      return store?.state?.users?.chosenWidget;
    },

    routeName() {
      return this.$route.name;
    },

    visibleHistories() {
      if (this.filter === HISTORIES_TYPES.ANONYMOUS) {
        return this.historyList?.filter((item) => this.isAnonymous(item?.user));
      }

      if (this.filter === HISTORIES_TYPES.NOT_ANONYMOUS) {
        return this.historyList?.filter(
          (item) => !this.isAnonymous(item?.user)
        );
      }

      if (this.filter === HISTORIES_TYPES.FAVORITE) {
        return this.historyList?.filter((item) => item?.favorite);
      }

      return this.historyList;
    },

    historyTitle() {
      const { name, email, phone } = this.historyChat?.user;

      return name || email || phone || `Id #${this.selected?.id}`;
    },
  },

  watch: {
    chosenWidget: {
      handler: "firstDataLoad",
      immediate: true,
      deep: true,
    },

    selected: {
      handler: "selectedHistoryLoad",
      immediate: true,
    },

    historyChat: {
      handler() {
        const container = this.$el.querySelector("#messagesCard");
        this.$nextTick(() => {
          container.scrollTop = container.scrollHeight;
        });
      },
      deep: true,
    },
  },

  mounted() {
    this.firstDataLoad();
  },

  methods: {
    async firstDataLoad() {
      this.historyList = [];
      this.selected = null;

      if (this.chosenWidget) {
        const data = await this.getHistoryList();
        this.historyList = data;
      }
    },

    async refreshHistory() {
      store.dispatch("startLoading");

      if (this.chosenWidget) {
        try {
          const data = await this.getHistoryList();

          if (data) {
            this.historyList = data;
          }

          if (this.selected) {
            this.selectedHistoryLoad();
          }
        } catch (error) {
          console.error(error);
          this.$toast.error(
            error?.response?.data?.errorDescription || "Refresh error"
          );
        } finally {
          store.dispatch("endLoading");
        }
      }
    },

    async getHistoryList() {
      store.dispatch("startLoading");

      try {
        if (this.chosenWidget) {
          const { data } = await DataService.get(
            `${API_ENDPOINT}history/widget/${this.chosenWidget?.id}`
          );
          return data;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "History list load error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    getTimeFromLastUpdate(date) {
      const time = moment(new Date(date)).fromNow();

      const returnTime = (timeString) => {
        if (timeString === "a few seconds ago") {
          timeString = "new";
        }

        if (timeString.includes("minute")) {
          timeString = timeString.replace("minute", "min");
        }

        if (timeString.includes("minutes")) {
          timeString = timeString.replace("minutes", "min");
        }

        return timeString;
      };

      return returnTime(time);
    },

    isAnonymous(user) {
      const { userImg, ...data } = user;
      return Object.values(data).every((item) => item === "");
    },

    setFilterType(type) {
      this.filter = type;
    },

    async selectedHistoryLoad() {
      store.dispatch("startLoading");

      try {
        if (this.chosenWidget && this.selected) {
          const { data } = await DataService.get(
            `${API_ENDPOINT}history/${this.selected?.id}`
          );

          this.historyChat = data;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "History load error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    handleChatItemClick(item) {
      this.selected && this.selected?.id === item?.id
        ? (this.selected = null)
        : (this.selected = item);
    },

    async selectedHistoryDownload() {
      store.dispatch("startLoading");

      try {
        if (this.chosenWidget && this.selected) {
          const response = await axios.get(
            `${API_ENDPOINT}history/download/${this.selected?.id}`,
            {
              responseType: "blob",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          const blob = new Blob([response.data], { type: "text/plain" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `History_id-${this.selected?.id}.txt`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "History load error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    async allHistoryDownload() {
      store.dispatch("startLoading");

      try {
        if (this.chosenWidget) {
          const response = await axios.get(
            `${API_ENDPOINT}history/download/widget/${this.chosenWidget.id}`,
            {
              responseType: "blob",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          const blob = new Blob([response.data], { type: "text/plain" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Widget_${this.chosenWidget?.settings?.name}.txt`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "History load error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    async toggleFavorite() {
      store.dispatch("startLoading");

      try {
        if (this.chosenWidget) {
          const response = await DataService.get(
            `${API_ENDPOINT}history/favorite/${this.selected?.id}`
          );

          if (response.status === 200) {
            const idx = this.historyList.findIndex(
              (item) => item.id === this.selected?.id
            );
            this.historyList[idx].favorite = !this.historyList[idx].favorite;
          }
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Add to favorite error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },

    isFavorite(id) {
      if (this.selected) {
        if (id === "#star" || id === "#star_light") {
          return this.selected?.favorite;
        }
      }
    },
  },
};
</script>

<template>
  <div class="page_box">
    <div class="header">
      <div class="page_container">
        <h1 class="title">Chat history</h1>
      </div>
    </div>

    <div class="history_table">
      <div class="history_left-side">
        <div class="history_header table_container">
          <Select
            :items="selectItems"
            @onSelect="setFilterType"
            :disabled="historyList.length === 0"
          />

          <div class="history_actions">
            <button
              v-for="icon of historyActionsIcons"
              class="action_button history_action"
              @click="icon.action"
              :disabled="icon.id !== '#refresh' && historyList.length === 0"
            >
              <svg>
                <use :xlink:href="`${icon.source}${icon.id}`" />
              </svg>
            </button>
          </div>
        </div>

        <div class="table_container chat_list">
          <p v-show="visibleHistories.length === 0" class="no_data">
            No data to show
          </p>

          <ChatList
            v-show="visibleHistories.length > 0"
            :chatList="visibleHistories"
            :selected="selected"
            @chatItemClick="handleChatItemClick"
          />
        </div>
      </div>

      <div class="history_right-side">
        <div class="history_header table_container">
          <h5 v-if="selected" class="history_username">{{ historyTitle }}</h5>

          <div v-if="selected" class="history_actions">
            <button
              v-for="icon of chatActionsIcons"
              class="action_button chat_action"
              :class="{
                favorite: isFavorite(icon.id),
              }"
              @click="icon.action"
            >
              <svg>
                <use
                  :xlink:href="`${
                    !isFavorite(icon.id) ? icon.source : icon.source_2
                  }${!isFavorite(icon.id) ? icon.id : icon.id_2}`"
                />
              </svg>
            </button>

            <button
              class="history_details-button"
              @click="() => (showModal = true)"
            >
              View details
            </button>
          </div>
        </div>

        <div id="messagesCard" class="table_container chat_container">
          <Chat
            v-if="selected"
            :messages="historyChat.messages"
            :user="historyChat.user"
            :userName="historyTitle"
          />
        </div>
      </div>
    </div>

    <Modal :isModalOpen="showModal" @close="showModal = false">
      <div v-if="selected" slot="body" class="modal_body">
        <div>
          <h5 class="history_username">Chat id #{{ selected.id }}</h5>
          <p class="modal_text">
            Favorite: <span>{{ selected.favorite }}</span>
          </p>

          <p class="modal_text">
            last update:
            <span>{{ getTimeFromLastUpdate(selected.finishedAt) }}</span>
          </p>
        </div>

        <div>
          <h5 class="history_username">User</h5>
          <p
            class="modal_text"
            v-if="item[0] !== 'userImg'"
            v-for="item of Object.entries(selected.user)"
          >
            {{ item[0] }}: <span>{{ item[1] === "" ? "-" : item[1] }}</span>
          </p>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style scoped lang="scss">
.page_box {
  width: 100%;
  height: calc(100vh - 66px);
  padding: 62px 0 38px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media screen and (max-width: 768px) {
    padding: 32px 0;
  }
}

.page_container {
  width: 100%;
  padding: 0 38px;

  @media screen and (max-width: 768px) {
    padding: 0 16px;
  }
}

.header {
  padding-bottom: 31px;
  border-bottom: 1px solid #ededed;
}

.title {
  padding: 0;
  margin: 0;
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.table_container {
  padding: 17px 12px;
}

.chat_container,
.chat_list {
  overflow: auto;
  height: 100%;
}

.chat_list {
  @media screen and (max-width: 768px) {
    max-height: 285px;
  }
}

.history_table {
  display: grid;
  grid-template-columns: 35% 65%;
  height: 100%;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.history_left-side {
  font-size: 14px;
}

.history_right-side {
  font-size: 14px;
  border-left: 1px solid #ededed;
}

.history_left-side,
.history_right-side {
  height: calc(709px - 71px);

  @media screen and (max-width: 768px) {
    height: 100%;
  }
}

.history_header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  min-height: 71px;

  @media screen and (max-width: 940px) {
    flex-direction: column;
    gap: 8px;
    min-height: 107px;
  }
}

.history_username {
  margin: 0;
  padding: 0;
  color: #333;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.8;
}

.history_actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action_button {
  background-color: transparent;
  outline: none;
  border: none;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  transition: all ease-in-out 300ms;
  border-radius: 6px;

  &:hover {
    background-color: #f2f2f2;
  }

  & > svg {
    fill: inherit;
    width: 24px;
    height: 24px;
  }
}

.history_action {
  fill: #222222;
}

.chat_action {
  fill: #828282;
}

.favorite {
  fill: #3056d3;

  &:hover {
    background-color: #ebf0ff;
  }
}

.history_details-button {
  background-color: #ebf0ff;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  transition: all ease-in-out 300ms;
  border: 1px solid #3056d3;
  border-radius: 6px;
  color: #3056d3;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.71;

  &:hover {
    background-color: #dadfec;
  }
}

.modal_body {
  display: flex;
  gap: 32px;
  width: 100%;
  flex-direction: column;
}

.modal_text {
  color: #333;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
  padding: 0;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  & > span {
    font-weight: 700;
  }
}

.no_data {
  margin-top: 32px;
  color: #637381;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;
}
</style>
